import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class UIComponent extends SlotGame.src.component.UIComponent {

  public onInfoClick() {
    super.onInfoClick();
    this.getFixWidthJapanTextPaytable();
  }

  public onRulesClick() {
    super.onRulesClick();
    this.getFixWidthJapanTextRules();
    this.getFixWidthPolandTextRules();
  }


    constructor(config: BaseComponentConfig) {
        super(config);

        const store = <SlotGameStore>game.store;

        this.text_checkers = {
            ...super.getTextCheckers(),
            GET_SYMBOL_COUNT_PAYOUT_X: (element) => {
                const {symbol, count} = element.options.data;
                const payout = store.gameRules.getSymbolPayouts(symbol)[count - 1];
                const payInCent = store.gameData.bet * payout;

                return `x${count} - ${store.toFormatMoney(payInCent)}`;
            }
        }
    }

    setMobilePortraitConfigTextWidth(elementName, maxWidth = 1030, positionX = 0) {
    const elementObj = game.tree.findByName(elementName);
    if (elementObj === undefined) {
        throw console.error(`game.tree.findByName: ${elementName} --- undefined`);
    }

    if(positionX) {
        //Set position.x + width
        elementObj.options.layout.mobile_portrait["wordWrap"] = false;
        elementObj.options.layout.mobile_portrait["width"] = maxWidth;
        elementObj.options.layout.mobile_portrait["position"]["x"] = positionX;

    } else {
        //Set width
        elementObj.options.layout.mobile_portrait["wordWrap"] = false;
        elementObj.options.layout.mobile_portrait["width"] = maxWidth;
    }
  }

  getFixWidthJapanTextPaytable() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "ja";
    if (isNotPoloshLanguage) return

    this.onChangeOrientation();
  }

  getFixWidthJapanTextRules() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "ja";
    if (isNotPoloshLanguage) return

    this.setMobilePortraitConfigTextWidth("game_rules.table.button_doubling.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_switch_bet.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_icon_menu.descr", 650);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_settings.descr", 650);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.name_value", 150, -300);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_rules.descr", 650);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_close.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_home.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.descr", 700);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.name_value", 200, -265);

    this.onChangeOrientation();
  }

  getFixWidthPolandTextRules() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "pl";
    if (isNotPoloshLanguage) return

    this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.name_value", 200, -255);

    this.onChangeOrientation();
  }

  get store(): SlotGameStore {
    return <SlotGameStore>game.store;
  }
}

//@ts-ignore
Game.src.component.UIComponent = UIComponent;
